export interface LiveSport {
  Name: string;
  NodeId: string;
  SportId: string;
  SportHandle: string;
  Leagues: any[];
}
